const isProduction: boolean = process.env.NODE_ENV === 'production';

const dataTest = (value: string): { 'data-testid': string } | null => {
  const attribute = isProduction ? null : { 'data-testid': value };

  return attribute;
};

export default dataTest;
